import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'helpers/GlobalHelper';
import Overlay from 'components/Overlay';

const MVPDRetry = ({
  backgroundUrl,
  isActive,
  mvpdRetryChildren,
  mvpdRetryTheme,
  backgroundClass,
  children,
  retryButtonClick,
  otherProviderClick,
  onCloseClick,
  sharedTheme,
}) => {
  if (!isActive) return null;
  return (
    <Overlay
      backgroundClass={backgroundClass}
      backgroundUrl={backgroundUrl}
      theme={mvpdRetryTheme}
      sharedTheme={sharedTheme}
      rendered={isActive}
      innerContainerChildren={mvpdRetryChildren}
      innerContainerChildrenParams={{ retryButtonClick, otherProviderClick, onCloseClick }}
    >
      {children}
    </Overlay>
  );
};

MVPDRetry.defaultProps = {
  backgroundUrl: null,
  isActive: false,
  mvpdRetryChildren: noop,
  mvpdRetryTheme: {},
  backgroundClass: null,
  children: null,
  retryButtonClick: noop,
  otherProviderClick: noop,
  onCloseClick: noop,
  sharedTheme: {},
};

MVPDRetry.propTypes = {
  backgroundUrl: PropTypes.string,
  isActive: PropTypes.bool,
  mvpdRetryChildren: PropTypes.func,
  mvpdRetryTheme: PropTypes.shape({}),
  backgroundClass: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  retryButtonClick: PropTypes.func,
  otherProviderClick: PropTypes.func,
  onCloseClick: PropTypes.func,
  sharedTheme: PropTypes.shape({}),
};

export default MVPDRetry;
